'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsApplications = function MdSettingsApplications(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.8 20c0-0.4 0-0.8-0.1-1.2l2.5-1.8c0.2-0.2 0.2-0.6 0.1-0.8l-2.4-4.1c-0.1-0.2-0.5-0.3-0.7-0.2l-2.9 1.1c-0.6-0.4-1.2-0.8-1.9-1.1l-0.5-3.1c-0.1-0.2-0.2-0.4-0.6-0.4h-4.6c-0.4 0-0.5 0.1-0.6 0.4l-0.5 3.2c-0.7 0.3-1.3 0.6-1.9 1l-2.9-1.1c-0.2-0.1-0.5 0.1-0.7 0.3l-2.3 4c-0.2 0.2-0.2 0.6 0 0.8l2.5 1.8c0 0.4 0 0.8 0 1.2s0 0.8 0 1.2l-2.5 1.8c-0.2 0.2-0.2 0.6 0 0.8l2.3 4.1c0.2 0.2 0.5 0.3 0.7 0.2l2.9-1.1c0.6 0.4 1.2 0.8 1.9 1.1l0.5 3.1c0.1 0.2 0.2 0.4 0.6 0.4h4.6c0.4 0 0.5-0.1 0.6-0.4l0.5-3.2c0.7-0.3 1.3-0.6 1.9-1l2.9 1.1c0.2 0.1 0.6-0.1 0.7-0.3l2.4-4c0.1-0.2 0.1-0.6-0.1-0.8l-2.5-1.8c0.1-0.4 0.1-0.8 0.1-1.2z m2.8-15c1.9 0 3.4 1.6 3.4 3.4v23.2c0 1.8-1.5 3.4-3.4 3.4h-23.2c-1.9 0-3.4-1.6-3.4-3.4v-23.2c0-1.8 1.5-3.4 3.4-3.4h23.2z m-11.6 11.6c1.8 0 3.4 1.6 3.4 3.4s-1.6 3.4-3.4 3.4-3.4-1.6-3.4-3.4 1.6-3.4 3.4-3.4z' })
        )
    );
};

exports.default = MdSettingsApplications;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-applications.js
// module id = 1943
// module chunks = 168707334958949